import * as THREE from "three";
import { Server } from "../Server/Server"
function ObjectManager(id) {
    this.modelID = id;
}
ObjectManager.prototype = {
    constructor: ObjectManager,
    server: new Server(),
    modelID: "",
    needOpactyMesh: [],
    htHotPoints: {},
    meshs: [],
    modelPath: "",
    emissive: 0x969696,
    emissiveIntensity: 1,
    init: function (modelPath) {
        this.modelPath = modelPath;
    },
    setOpacity: function (state) {
        if (state) {
            this.needOpactyMesh.forEach((mesh) => {
             let mats = mesh.material;
        if (mats.length) {
            mats.forEach(mat => {
                mat.opacity = 0.5;
                mat.transparent= true;
            });
        } else {
            mats.opacity = 0.5;
            mats.transparent= true
        }
        });
        }else{
              this.needOpactyMesh.forEach((mesh) => {
             let mats = mesh.material;
        if (mats.length) {
            mats.forEach(mat => {
                mat.opacity = 1;
                mat.transparent= false;
            });
        } else {
            mats.opacity = 1;
            mats.transparent= false
        }
        });
        }
    },
    setAllEmissive: function (object, enableShadow) {
        this.enableShadow = enableShadow;
        this.meshs = this.getAllMesh(object);
        // this.resetMaterial();
        this.meshs.forEach((mesh) => {
            this.setMaterialToEmssive(mesh);
        })
    },
    configMaterials: function (object, enableShadow) {
        this.enableShadow = enableShadow;
        this.meshs = this.getAllMesh(object);
        // this.resetMaterial();
        this.meshs.forEach((mesh) => {
            if (mesh.name.indexOf("_em") != -1) {
                this.setMaterialToEmssive(mesh);
            }
            if (mesh.name.indexOf("_op") != -1) {
                this.needOpactyMesh.push(mesh);
            }
            if (mesh.name.indexOf("_hth") != -1) {
                this.htHotPoints[mesh.name] = mesh.position;
            }
        });
    },
    resetMaterial: function () {
        for (var i = 0; i < this.meshs.length; i++) {
            var mesh = this.meshs[i];
            if (mesh.material) {
                if (mesh.material.length) {
                    for (var j = 0; j < mesh.material.length; j++) {
                        if (mesh.material[j].color) {
                            mesh.material[j].color = new THREE.Color(0xffffff);
                        }

                    }
                } else {
                    if (mesh.material.map != null) {
                        mesh.material.color = new THREE.Color(0xffffff);
                    }

                }
            }
        }
    },
    // resetMaterial:function(){
    //     for(var i=0;i<this.meshs.length;i++){
    //         var mesh=this.meshs[i];
    //         if(mesh.material){
    //             if(mesh.material.length){
    //                 for(var j=0;j<mesh.material.length;j++){
    //                     var data={};
    //                     data["id"]=this.modelID;
    //                     var map={};
    //                     console.log(mesh.name);
    //                     data["meshName"]=mesh.name;
    //                     map[mesh.material[j].name]={};
    //                     data["maps"]=map;
    //                     this.server.getMaps(data,this.getMapsCallBaCK)
    //                     if(mesh.material[j].color){
    //                         mesh.material[j].color=new THREE.Color(0xffffff);
    //                     }

    //                 }
    //             }else{
    //                 var data={};
    //                 data["id"]=this.modelID;
    //                 var map={};
    //                 console.log(mesh.name);
    //                     data["meshName"]=mesh.name;
    //                 map[mesh.material.name]={};
    //                 data["maps"]=map;
    //                 console.log(data);
    //                 this.server.getMaps(data,this.getMapsCallBaCK);
    //                 if(mesh.material.map!=null){
    //                     mesh.material.color=new THREE.Color(0xffffff);
    //                 }

    //             }
    //         }else{
    //             console.log(mesh)
    //         }
    //     }
    // },
    //pbr材质，获根据材质名称获取所有的贴图回调
    getMapsCallBaCK: function (res) {
        for (var i = 0; i < this.meshs.length; i++) {
            var mesh = this.meshs[i];
            if (res["meshName"] === mesh.name) {
                if (mesh.material.length) {
                    console.log("有多个材质");
                    for (var j = 0; j < mesh.material.length; j++) {

                    }
                } else {
                    console.log("单个材质");
                }
            } else {
                console.log("名字不同");
            }
        }
    },
    getAllMesh: function (object) {
        let meshs = [];
        object.children.forEach((child) => {
            if (child.isMesh) {
                child.castShadow = this.enableShadow;
                child.receiveShadow = this.enableShadow;
                meshs.push(child);
            } else if (child.isGroup) {
                let mesh1s = this.getAllMesh(child);
                meshs.push.apply(meshs, mesh1s);
            }
        })
        return meshs;
    },
    setMaterialToEmssive: function (mesh) {
        if (mesh.material.length) {
            mesh.material.forEach((mat) => {
                mat.emissiveMap = mesh.material.map;
                mat.shininess = 30;
                mat.emissiveIntensity = 1;
                mat.emissive = new THREE.Color(this.emissive);
            });
        } else {
            mesh.material.emissiveMap = mesh.material.map;
            mesh.material.shininess = 30;
            mesh.material.emissiveIntensity = 1;
            mesh.material.emissive = new THREE.Color(this.emissive);
        }
    },
    setMaterialtoOpactiy: function (material) {
        if (material.length) {
            material.forEach((mat) => {
                mat.opacity = 0.6;
                mat.transparent = true;
            });
        } else {
            material.opacity = 0.6;
            material.transparent = true;
        }
    },
    setMaterialtoNormal: function (material) {
        if (material.length) {
            material.forEach((mat) => {
                mat.opacity = 1;
                mat.transparent = false;
            });
        } else {
            material.opacity = 1;
            material.transparent = false;
        }
    },
    getAllMaterial(material) {
        let mats = [];
        if (material.length) {
            material.forEach((mt) => {
                mats.push(mt);
            })
        }
        return mats;
    },
    resetOpacity: function (opacity) {
    
        this.needOpactyMesh.forEach((child) => {
            if (opacity) {
                this.setMaterialtoOpactiy(child.material);
            } else {
                this.setMaterialtoNormal(child.material);
            }
        });
    },
    showInfo() {
        this.meshs.forEach((mesh) => {
            console.log(mesh)
        });
    }
}

export {
    ObjectManager
}